export default {
  NOT_FOUND: 'The requested resource was not found. Please try again later',
  PAGE_NOT_FOUND: 'Ops! The requested page was not found',
  RETRY_BUTTON_TITLE: 'Retry',
  INTERNAL_SERVER_ERROR: 'Something went wrong. Please try again later',
  ERROR_PAGE_TITLE: 'Something wrong!',
  ERROR_PAGE_DESCRIPTION: 'Please try again after sometime.',
  LAST_RECHARGE_TAG: 'LAST RECHARGE',
  FETCH_UPI_APPS_FAILURE: 'Ops! Failed to fetch UPI Apps in your device',
  PAYMENT_INITIATE_FAILURE: `Couldn't initiate payment. Please try again later`,
  DESKTOP_SUPPORT: `Desktop support is currently unavailable. Please try again from your mobile device`,
  CONTINUE_PAYMENT: 'Continue Payment',
  PLAN_VALIDATION_ERROR_TITLE: `Unable to validate plan`,
  PLAN_VALIDATION_ERROR_BODY: `Please try again later`,
  PLAN_VALIDATION_ERROR_CTA: `Okay, got it`,
  NO_RESULT_FOUND: 'No results found',
  PLAN_SELECTION_PAGE_LOADER_TITLE: 'Loading prepaid plans...',
  PLAN_SELECTION_PAGE_LOADER_DESCRIPTION: `This won't take more than 5 seconds`,
  OKAY_GOT_IT: `Okay, got it`,
  OR: 'or',
  TRY_OTHER_PAYMENT_OPTION: `Oops! Please retry with another payment method`,
  CONTACT_SEARCH_FIELD_PLACEHOLDER: `Enter name or mobile number`,
  CONSUMER_NAME: 'Consumer Name',
  BILL_DATE: 'Bill date',
  BILL_NUMBER: 'Bill Number',
  DUE_DATE: 'Due date',
  AMOUNT: 'Amount',
  NO_BILLS_TITLE: 'Your bill is already paid',
  NO_BILLS_DESCRIPTION: 'We’ll notify you when there’s a bill due',
  BILLS_LOADER_TITLE: 'Loading your bill...',
  BILLS_LOADER_DESCRIPTION: 'This won’t take more than 5 seconds',
  PHONE_CONTACTS_LOADER_TITLE: `Fetching phone contacts...`,
  PHONE_CONTACTS_LOADER_DESCRIPTION: `This won't take more than a few seconds`,
  EARNED_SUPER_COINS: 'Earned $supercoinAmount coins',
  SUPERCOIN_BALANCE: 'Supercoin balance',
  ADD_BANK_AND_PAY: 'Add bank and pay',
  VERIFY_AND_PAY: 'Verify and pay',
  CANCEL: 'Cancel',
  REMOVE: 'Remove',
  FETCH_DEVICE_DETAILS_FAILED: `Couldn't fetch device details. Please check device permissions.`,
  RISK_TXN_LIMIT: 'Transaction was declined on the basis of risk checks',
  TRANSACTION_LIMIT_REACHED:
    'You have hit today’s limit for Recharges and Bill payments. Please try again tomorrow.',
  RECHARGE_TITLE: 'Prepaid recharge for ',
  TITLE_FKUPI: 'Pay with Flipkart UPI',
  AVAILABLE_SUPERCOINS: 'Available supercoins',
  ACTIVATE_FKUPI: 'Activate in less than three seconds',
  PULL_DOWN: 'Pull down to see history',
  PULL_UP: 'Pull up to see plans',
  YOU_PAID: 'You paid',
  RECHARGE_IN_PROGRESS: 'Recharge in progress',
  SUCCESS: 'SUCCESS',
  COMPLETED: 'COMPLETED',
  YOUR_BILL_AMOUNT: 'Your bill amount',
  PREPAID_TO_POSTPAID_LOADER_MSG: 'is a prepaid number',
  PREPAID_TO_POSTPAID_LOADER_SUB_MSG: 'Redirecting to Prepaid Recharges',
  PARTIAL_PAY_TITLE: 'Enter amount',
  PARTIAL_PAY_SUB_TITLE: 'Bill amount',
  PARTIAL_PAY_BODY: 'Enter any amount between',
  CONTINUE: 'Continue',
  PAY_MIN_AMOUNT: 'Pay minimum due amount',
  PAY_OTHER_AMOUNT: 'Pay other amount',
  ALL_BANKS: 'All banks',
}
